/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { FlatList, TouchableOpacity } from 'react-native';
import { IconSvg } from 'src/assets';
import { ReservationProps } from 'src/common/api/response';
import { keyExtractor } from 'src/common/utils/KeyExtractor';
import { DateTimeCalendar, IconLabel, RegularText, Row } from 'src/components';
import { Container } from 'src/components/bases/Container';
import { Navigation } from 'src/navigations/RootNavigation';
import { AppColors } from 'src/themes/Colors';
import { device, metrics, pixelScaler } from 'src/themes/Metrics';

export const UpcomingTrip = ({ data }: { data: ReservationProps[] }) => {
  return (
    <Container width="100%">
      <Row paddingHorizontal={metrics.large} marginTop={metrics.large} marginBottom={metrics.medium}>
        <RegularText fontWeight="bold" fontSize="large" textLang="upcomingTrip" />
      </Row>
      {data.length > 1 ? (
        <FlatList<ReservationProps>
          data={data || []}
          keyExtractor={keyExtractor}
          contentContainerStyle={{ paddingLeft: metrics.large }}
          horizontal
          showsHorizontalScrollIndicator={false}
          renderItem={({ item }) => {
            return (
              <TouchableOpacity
                activeOpacity={0.8}
                onPress={() => {
                  Navigation.navigate('MyTicketScreen', { bookingId: item.bookingId });
                }}>
                <Container
                  marginRight={metrics.large}
                  padding={metrics.large}
                  borderRadius={metrics.borderRadius}
                  backgroundColor={AppColors.white}
                  style={{ borderColor: AppColors.primary, borderWidth: 1, minWidth: device.width * 0.7 }}>
                  <DateTimeCalendar date={item.departureDate} time={item.departureTime} />
                  <Container height={metrics.small} />
                  <IconLabel
                    icon={<Container width={pixelScaler(16)} />}
                    label={
                      <Row>
                        <RegularText fontSize="medium" style={{ paddingRight: metrics.medium }} color={AppColors.gray}>
                          {item.fromLocation}
                        </RegularText>
                        <IconSvg.HeaderPointer fill={AppColors.gray} />
                        <RegularText fontSize="medium" color={AppColors.gray}>
                          {item.toLocation}
                        </RegularText>
                      </Row>
                    }
                  />
                </Container>
              </TouchableOpacity>
            );
          }}
        />
      ) : (
        <TouchableOpacity
          activeOpacity={0.8}
          onPress={() => {
            Navigation.navigate('MyTicketScreen', { bookingId: data[0].bookingId });
          }}>
          <Container
            marginHorizontal={metrics.large}
            padding={metrics.large}
            borderRadius={metrics.borderRadius}
            backgroundColor={AppColors.white}
            style={{ borderColor: AppColors.primary, borderWidth: 1 }}>
            <DateTimeCalendar date={data[0].departureDate} time={data[0].departureTime} />
            <Container height={metrics.small} />
            <IconLabel
              icon={<Container width={pixelScaler(16)} />}
              label={
                <Row>
                  <RegularText fontSize="medium" style={{ paddingRight: metrics.medium }} color={AppColors.gray}>
                    {data[0].fromLocation}
                  </RegularText>
                  <IconSvg.HeaderPointer fill={AppColors.gray} />
                  <RegularText fontSize="medium" color={AppColors.gray}>
                    {data[0].toLocation}
                  </RegularText>
                </Row>
              }
            />
          </Container>
        </TouchableOpacity>
      )}
    </Container>
  );
};
